export const DISCUSSION_TEXT_RESPONSE_SETTINGS = {
  placeholder: 'Add answer...',
  canChangeBlockType: false,
  canBold: false,
  canItalic: false,
  canUnderline: false,
  canAddLists: false,
  canChangeHistory: false,
  canChangeFonts: false,
  canAddLinks: false,
  canAlignText: false,
};

export const DISCUSSION_DRAW_CANVAS = {
  width: 1000,
  height: 700,
};
